var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24923 0C6.45901 0 4.74213 0.711159 3.47626 1.97703C2.21038 3.2429 1.49923 4.95979 1.49923 6.75V10.3515L0.0532264 13.9725C0.00793678 14.0862 -0.00883154 14.2093 0.00438483 14.331C0.0176012 14.4527 0.0604005 14.5693 0.129047 14.6706C0.197694 14.772 0.290102 14.855 0.398206 14.9124C0.506309 14.9698 0.626822 14.9999 0.749226 15H5.24923C5.24923 16.662 6.58723 18 8.24923 18C9.91123 18 11.2492 16.662 11.2492 15H15.7492C15.8716 14.9999 15.9921 14.9698 16.1002 14.9124C16.2083 14.855 16.3008 14.772 16.3694 14.6706C16.4381 14.5693 16.4809 14.4527 16.4941 14.331C16.5073 14.2093 16.4905 14.0862 16.4452 13.9725L14.9992 10.35V6.75C14.9992 4.95979 14.2881 3.2429 13.0222 1.97703C11.7563 0.711159 10.0394 0 8.24923 0ZM9.74923 15C9.74923 15.834 9.08323 16.5 8.24923 16.5C7.41523 16.5 6.74923 15.834 6.74923 15H9.74923ZM2.99923 6.75C2.99923 5.35761 3.55235 4.02226 4.53692 3.03769C5.52148 2.05312 6.85684 1.5 8.24923 1.5C9.64161 1.5 10.977 2.05312 11.9615 3.03769C12.9461 4.02226 13.4992 5.35761 13.4992 6.75V10.497C13.4995 10.5921 13.5178 10.6863 13.5532 10.7745L14.6422 13.5H1.85623L2.94523 10.7745C2.98065 10.6863 2.99898 10.5921 2.99923 10.497V6.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.71b40d71acf8fa36f985bf998b6d8ecc.svg";
export { ForwardRef as ReactComponent };